import TYPES from '@/types';

// Domain
import {
  LinkGoalsWealthStateManager,
} from '@/modules/flagship/investor-goal/link-sowos-wealth/domain/state/link-goals-wealth-state-manager';
import Inject from '@/modules/shared/domain/di/inject';
import Translator from '@/modules/shared/domain/i18n/translator';
import { Values } from '@/modules/shared/domain/i18n/types';
import { Router } from '@/modules/shared/domain/router';

export default class StepSuccessWealthViewModel {
  @Inject(TYPES.LINK_GOALS_WEALTH_STATE_MANAGER)
  readonly link_goals_wealth_state_manager!: LinkGoalsWealthStateManager;

  @Inject(TYPES.I18N)
  readonly translator!: Translator;

  @Inject(TYPES.ROUTER)
  private readonly router!: Router;

  readonly i18n_namespace = 'components.flagship.flagship-link-goals.step-success-wealth';

  link_goals_wealth_state = this.link_goals_wealth_state_manager.state;

  show_redirect_actions = false;

  translate = (message: string, values?: Values) => this.translator.translate(`${this.i18n_namespace}.${message}`, values);

  goToDashboardWealth = () => {
    window.location.href = '/sowos-wealth';
  }

  goToDashboardGoals = () => {
    window.location.href = '/goals-dashboard';
  }

  getRoute = () => {
    this.show_redirect_actions = this.router.current_path.path === '/goals-dashboard';
  }

  initialize = () => {
    this.getRoute();
  }
}
